import React from "react";
import defaultProfile from "../../../images/avatar/defaultuser.png";
import "./style.css";
import { formatOnlyDate, formatTime } from "../../../utils/functions/date";

const ScheduleAvatar = ({ schedule, handleClick, removeSchedule }) => {
  return (
    <div className="position-relative d-grid schedule-avatar" onClick={handleClick}>
      <i
        class="position-absolute fa-solid fa-circle-xmark"
        onClick={removeSchedule}
      ></i>
      <div className="schedule-avatar-date">
        {formatOnlyDate(schedule.date)}
      </div>
      <div className="schedule-avatar-time text-center">
        {`${formatTime(schedule?.start_time)} to ${formatTime(
          schedule?.end_time
        )}`}
      </div>
    </div>
  );
};

export default ScheduleAvatar;
